/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Nav_HomeInputs */

const cs_public_site_nav_home = /** @type {(inputs: Public_Site_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídka`)
};

const en_public_site_nav_home = /** @type {(inputs: Public_Site_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Public_Site_Nav_HomeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_nav_home = /** @type {((inputs?: Public_Site_Nav_HomeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Nav_HomeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_nav_home(inputs)
	return cs_public_site_nav_home(inputs)
});